module.exports = __webpack_public_path__ + "static/media/bg-elements.b448e19e.png";